module.exports = "//static.hsappstatic.net/salesImages/static-1.403/onboarding/enable-crm-permissions.png"